import type { FC } from 'react';
type CarRentalIconProps = {
  width?: number;
  height?: number;
};
export const CarRentalIcon: FC<CarRentalIconProps> = ({ width, height }) => {
  return (
    <svg
      width={width || 30}
      height={height || 30}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" fill="url(#pattern0)" />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_20_219" transform="scale(0.0111111)" />
        </pattern>
        <image
          id="image0_20_219"
          width="90"
          height="90"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEO0lEQVR4nO2cTYhVZRjHfzU5OW5SQsop3Zhb107YxjZJoYkLcaUoBvnVImoEcebOInRXIAb5lSgJQrgSs9SFUEEwW791M1BRmKGOo/l14oVn4HC577nXe++c53nPPD94uHDuOff8n/99z/t13nOgfBYA24AzwBVgHHgA/A6cBj4D5ivoqgxvAoeAJ0DWJB4D3wL92qJT40PgXgsG18c/wEpt8anwCfC0DZMnI1wBG7WTSKEkP+3A5LzZ72snY7lObqe6yCLxNzBXOymLHO6iyVkJsYcEWdBi7yIzFjUSY7sB07LpULJ/iCTxH/C59I9DDMq2zFgkw9VIAoMN9h00YGyyRsd6G/Ma7Pu6AWMrZ3R/g33fMGDstKg6dhgwNlmjixrDQW8Mu8dW5RI5HGlkY9vr90mG+YoDllpOR62F7bFjk+GgssmT1Aq2J2/yZG/ibhdN/MsnleKs6OI06fISC0mSbO/CxP8G7SRSKtl32zD5FvCBtvjU6AcOtNgbeSSNaaMhu/Mcd162yNKCyzJcnwDGgFPAp37323Ecx3EcJ7U5kCHgZxmQlDXhdEvOOSQaKstLwAjwUGFWrz4eymxd0FQpZgE/GTC4PsIa7T4qxPcGTI3FCSrCWgNmNos1JM4LwCUDRjaLi6I1WZY2qR8XAz0l6OiRc/1YoCdoTZa9kaQuATMU9PTKA0qNNAWtSfIi8Eckqc2KurZENP1Z0tXVdd6NJPQEeE1R11x56quRtmUkyP5IMue0hQHnI9q+ITFmFAyvN2mLAz4qeNwu1OPJsLzgXuCr2uKAOQUL4N8jIY5EkjiN/YWY4YndJHgZ+DeSxDrssD6i8Q4wk0TWcMR6GwPAO8AqqSd3Al8Cx6S0XwBGJcId8psStyXGc783nts+ud/l3PEX5DePyTl2yjlXiYaBgqUPIQfzHC9hyJxNcXyHYXpkIDJhwKiswwg5fGxxADNb+sdZxeIs8ApGCA3HbwZMyaYofrXSOH5lwIxsiiM0pqosKpg3qFI8AhZqGr3bgAlZSfGFptGjBgzISorQDqlxp0DYfWCXXHK98jlkpPvXjrYw2lXjWUEiSyLHDCib3a62kKsasWRCaSliWNHoTrSpERPUrIV+S9HoTrSpERPU28IMX6YUnWhTo91Ss8hwiS7SpkZMUGjBi6gpGt2JNjVigiakBW/E28q9jk60qdEsoWFpXHrlsyZv1tUyuVNtJo2uYqihnXjmRuubknmJRt0wrzqwHV5H40arl0Iv0egbV6mqY7UsBdsqb20Mrw3+GjgKnJRb+qO5uJZbeTSWW410u+7+5OO678Zyx12r+82zcq5wzn2iYYdoWicakzc6FUzn0uy1PeH7VDCdy40m4sIlnAqmcxmp0Hs+Ryzn0idLphoJ+yWx56z7rOfSJ1OM1+Vxhevy76sLm+a5OI7jOI7jOI7jOI7jMFX8D3+65jWDiUNuAAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>
  );
};
